const groupPrefix = createApiRoute(ApiModule.WAREHOUSE, ApiAuthorization.EMPLOYEE, ApiDataModel.MAPPING)

export const apiWarehouse = {
	CRMSynchronization: async () =>
		await apiCommon(`${groupPrefix}/sync`, {
			method: 'POST',
		}),

	downloadXlsxExport: async () => {
		const response = await apiCommon<Blob>(`${groupPrefix}/export`, {
			method: 'GET',
			responseType: 'blob',
		})
		const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
		const url = URL.createObjectURL(blob)
		const link = document.createElement('a')
		link.href = url
		link.setAttribute('download', 'export.xlsx')
		document.body.appendChild(link)
		link.click()
		return response
	},

	importMesCategory: async (file: File) => {
		const mesCategoryPrefix = createApiRoute(
			ApiModule.WAREHOUSE,
			ApiAuthorization.EMPLOYEE,
			ApiDataModel.MES_CATEGORY,
		)
		const formData = new FormData()
		formData.append('file', file)
		return await apiCommon(
			`${mesCategoryPrefix}/import`,
			{
				method: 'POST',
				body: formData,
			},
			'pl',
			true,
		)
	},
}
